import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {Platform, PlatformDisplay} from "@/lib/types/monitoring.ts";

import {KubernetesDialogContent} from "./KubernetesDialogContent.tsx";
import {UbuntuDialogContent} from "./UbuntuDialogContent.tsx";

interface DeployAssistantProps {
  platform: Platform;
  onClose: () => void;
}

export const DeployAssistant = ({platform, onClose}: DeployAssistantProps) => {
  if (![Platform.UBUNTU, Platform.KUBERNETES].includes(platform)) {
    return null;
  }

  return (
    <ActionDialog
      show={true}
      onCancel={onClose}
      onConfirm={onClose}
      hasConfirmButton={false}
      title={`Downloaded ${PlatformDisplay[platform]} installation`}
      hasCancelButton={false}
    >
      {platform === Platform.UBUNTU && <UbuntuDialogContent />}
      {platform === Platform.KUBERNETES && <KubernetesDialogContent />}
    </ActionDialog>
  );
};
